module.exports = __webpack_public_path__ + "media/images/charactor1-25bf5ae7d4bf870c49bed5cb27bb5f0f.png";